import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type RangeFilter } from '../types/filters';

const DEFAULT_MIN_HIRING_RATE = 0;
const DEFAULT_MAX_HIRING_RATE = 25;

export const hiringRateDefinition: FilterDefinition<RangeFilter> = {
  id: FilterId.HIRING_RATE,
  name: 'Hiring Rate',
  type: FilterType.RANGE,
  min: DEFAULT_MIN_HIRING_RATE,
  max: DEFAULT_MAX_HIRING_RATE,
  isActive: false,
  isVisible: true,
};

export const hiringRateHandler: FilterHandler<RangeFilter> = {
  isActive(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min !== undefined ||
      currentFilterState.max !== undefined
    );
  },
  isDefault(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined
    );
  },
  getEffectiveFilter(currentFilterState: RangeFilter) {
    // Only apply defaults if BOTH min and max are undefined
    // If only one is undefined, keep it undefined (for "greater than" / "less than" filters)
    const shouldApplyDefaults =
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined;

    if (shouldApplyDefaults) {
      return {
        ...currentFilterState,
        min: DEFAULT_MIN_HIRING_RATE,
        max: DEFAULT_MAX_HIRING_RATE,
      };
    }

    // Preserve the user's selection - don't fill in undefined values
    return currentFilterState;
  },
};
